import script from "./MarkerCategoryTableItem.vue?vue&type=script&setup=true&lang=js"
export * from "./MarkerCategoryTableItem.vue?vue&type=script&setup=true&lang=js"

import "./MarkerCategoryTableItem.vue?vue&type=style&index=0&id=b3fc750a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b3fc750a"]])

export default __exports__